import { useTranslation } from 'react-i18next';

export const useTabLabels = (isRpc: boolean): string[] => {
  const { t } = useTranslation('case_details_tabs');
  return isRpc
    ? [t('map', 'Map'), t('documents', 'Documents')]
    : [
        t('details', 'Details'),
        t('map', 'Map'),
        t('related_cases', 'Related cases'),
        t('documents', 'Documents'),
        t('plans', 'Plans'),
        t('comments', 'Comments'),
      ];
};
